import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import {
    injectConfigAPI,
    injectFetch,
    injectLog,
    injectProgressPromise,
    injectZip,
    TYPES as UTIL_TYPES,
} from '@monofe/util';
import { bindSiteDataAPI, injectSiteDataAPI, TYPES, unbindSiteDataAPI } from '../interface/bind';
import type { ISiteDataAPI } from '../interface/siteData';
import getSiteDataAPI from './siteData';

function _build(container: IContainer): Readonly<ISiteDataAPI> {
    const promiser = injectProgressPromise(container);
    const fetcher = injectFetch(container);
    const zip = injectZip(container);
    const log = injectLog(container);
    const config = injectConfigAPI(container);

    const module: ISiteDataAPI = {
        getSiteData: (apiURL: string, authToken: string, hash?: string, timeout?: number) =>
            getSiteDataAPI(promiser, fetcher, zip, log, config, authToken, hash, timeout),
    };

    return Object.freeze(module);
}

export default buildBindable<ISiteDataAPI>({
    id: TYPES.ISiteDataAPI,
    dependencies: [
        UTIL_TYPES.IProgressPromiseGenerator,
        UTIL_TYPES.IFetch,
        UTIL_TYPES.IZip,
        UTIL_TYPES.IConfigAPI,
    ],
    bind: bindSiteDataAPI,
    remove: unbindSiteDataAPI,
    build: container => Promise.resolve(_build(container)),
    inject: injectSiteDataAPI,
});
